import {ui} from "@Common/ui-components/heavy/item-options/modules/expo-types/expo-types";

import {MailingClass} from "./mailing-class";

/**
 * UI Only, the logic is in built-in item-options already
 */
export const mailingClassModules = ({templateOptions, item}) => [
    {
        load: ({mailingClass2,paperPrices}, next) => next({
            ui: mailingClass2?.ui && MailingClass({
                paperPrices,
                className: "section",
                templateOptions,
                item,

                ...mailingClass2.ui,
            }),
        }),
        requires: ["mailingClass2","paperPrices"],
        expo: [ui("mailingClass")],
    },
];
